module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "downloadsPanel"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "blueTitle largeTitle",
      "title": _vm.$t('message.downloadsAppBarText'),
      "subTitle": _vm.$t('message.lessonDownloadsThisWeek')
    }
  }), _vm._v(" "), _c('mu-list', _vm._l((_vm.downloads), function(download, index) {
    return _c('mu-list-item', {
      key: 'download-' + index,
      attrs: {
        "disableRipple": "",
        "title": download.title
      },
      nativeOn: {
        "click": function($event) {
          return _vm.saveTrackingCount(download)
        }
      }
    }, [_c('mu-avatar', {
      attrs: {
        "slot": "leftAvatar",
        "src": download.image_url
      },
      slot: "leftAvatar"
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('span', {
      staticStyle: {
        "color": "rgba(0, 0, 0, .87)"
      },
      domProps: {
        "textContent": _vm._s(download.description)
      }
    })]), _vm._v(" "), _c('mu-icon', {
      attrs: {
        "slot": "right",
        "value": "file_download"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.saveTrackingCount(download)
        }
      },
      slot: "right"
    })], 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ba9437a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lesson/DownloadsPanel/DownloadsPanel.vue
// module id = 3798
// module chunks = 1